<template>
	<div class="main" style="min-height:768px;">
		<section class="panel">
			<header class="panel-heading">
				<h2 class="panel-title">扣(銷)點明細</h2>
			</header>
			<div class="panel-body container-fluid">
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label class="col-xs-3 col-md-5">學&emsp;&emsp;號：</label>
						<div v-if="this.isSaveShow" class="col-xs-9 col-md-7">
							<div class="col-xs-8">
								<input type="text" name="account" v-model="violateRecord.account" placeholder="學號" class="form-control" v-validate="'required'"/>
								<span class="text-danger" v-show="errors.has('account')">{{ errors.first('account') }}</span>
							</div>
							<div class="col-xs-4">
								<button type="button" class="btn s_btn_b" @click="searchStu()">查詢</button>
							</div>
						</div>
						<div v-else class="col-xs-9 col-md-7">{{violateRecord.account}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label class="col-xs-3 col-md-5">學&emsp;&emsp;制：</label>
						<div class="col-xs-9 col-md-7">{{model.deptSsymStr}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label class="col-xs-3 col-md-5">性&emsp;&emsp;別：</label>
						<div class="col-xs-9 col-md-7">{{model.sexStr}}</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">姓&emsp;&emsp;名：</label>
						<div class="col-xs-9 col-md-7">{{model.name}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">科系班級：</label>
						<div class="col-xs-9 col-md-7">
							<span v-if="model.deptCodeStr">{{model.deptCodeStr}}-{{model.drade}}年{{model.dradeClass}}班</span>
						</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">宿&emsp;&emsp;舍：</label>
						<div class="col-xs-9 col-md-7">{{model.bedFloor}}</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">聯絡電話：</label>
						<div class="col-xs-9 col-md-7">{{model.tel}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">行動電話：</label>
						<div class="col-xs-9 col-md-7">{{model.phone}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">寢&emsp;&emsp;室：</label>
						<div class="col-xs-9 col-md-7">{{model.bedRoom}}</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">常用信箱：</label>
						<div class="col-xs-9 col-md-7">{{model.extMail}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">學校信箱：</label>
						<div class="col-xs-9 col-md-7">{{model.schMail}}</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">床&emsp;&emsp;位：</label>
						<div class="col-xs-9 col-md-7">{{model.bed}}</div>
					</div>
				</div>
				<!-- <div class="row form-group" v-if="violateRecord.revokeApply == 'Y'">
					<div class="col-md-4 form-group" >
						<label v-bind:class="'col-xs-3 col-md-5'">銷點類型：</label>
						<div class="col-xs-9 col-md-7" v-if="isSaveShow">
							<select  class="form-control" v-model="violateRecord.violateName" name="violateSno" v-validate="'required'">
								<option :value="null">--請選擇--</option>
								<option v-for="(award, index) in awardTypeList" :key="index" :value="award.commValue">{{award.commValue}}</option>
							</select>
							<span class="text-danger" v-show="errors.has('violateSno')">{{ errors.first('violateSno') }}</span>
						</div>
						<div class="col-xs-9 col-md-7" v-else>
							<span>{{violateRecord.violateName}}</span>
						</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">點數：</label>

						<div class="col-xs-9 col-md-7" v-if="isSaveShow">
							<input type="number" v-model.number="violateRecord.violatePoint" name="violatePoint" class="form-control" v-validate="'required'"/>
							<span class="text-danger" v-show="errors.has('violatePoint')">必填欄位</span>
						</div>
						<div class="col-xs-9 col-md-7" v-else>
							{{violateRecord.violatePoint ? violateRecord.violatePoint : '--'}}
						</div>
					</div>
				</div> -->
				<div class="row form-group">
					<div class="col-md-4 form-group" >
						<label v-bind:class="'col-xs-3 col-md-5'">違規類型：</label>
						<div class="col-xs-9 col-md-7" v-if="storeData.editType=='E'">
							<span >{{violateRecord.violateName}}</span>
						</div>
						<div class="col-xs-9 col-md-7" v-else>
							<select  class="form-control" v-model="violateRecord.violateName" name="violateSno">
								<option :value="null">--請選擇--</option>
								<option v-for="(violate, index) in violateTypeList" :key="index" :value="violate.commValue">{{violate.commValue}}</option>
							</select>
							<span class="text-danger" v-show="errors.has('violateSno')">{{ errors.first('violateSno') }}</span>
						</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">點數：</label>
						<div class="col-xs-9 col-md-7" v-if="isSaveShow">
							<input type="number" v-model.number="violateRecord.violatePoint" name="violatePoint" class="form-control"/>

						</div>
						<div class="col-xs-9 col-md-7" v-else>
							{{violateRecord.violatePoint ? violateRecord.violatePoint : '--'}}
						</div>
					</div>
          <div class="col-md-4 form-group">
            <label v-bind:class="'col-xs-3 col-md-5 '">違規日期：</label>
            <div class="col-xs-9 col-md-7" v-if="isSaveShow">
              <datepicker name="leaveDate" v-validate="'required'" :format="customFormatter" :language="zh"
                    v-model="violateRecord.violateDate" input-class="form-control"
                    placeholder="違規日期" :style="{width:'auto', display:'inline-block'}" :calendarClass="'mobile_size'"/>
              <span class="text-danger" v-show="errors.has('violateDate')">{{ errors.first('violateDate') }}</span>
            </div>
            <div class="col-xs-9 col-md-7" v-else>
              {{customFormatter(violateRecord.violateDate)}}
            </div>
          </div>
				</div>
        <div class="row form-group">
          <div class="col-md-4 form-group">
            <label v-bind:class="'col-xs-3 col-md-5 '">登記日期：</label>
            <div class="col-xs-9 col-md-7">
              {{customFormatter(violateRecord.crDate)}}
            </div>
          </div>
        </div>
				<div class="row form-group">
					<div class="col-md-12">
						<label>違規紀錄說明:(請詳述人、事、時、地、物) </label>
					</div>
					<div class="col-md-12">
						<textarea v-if="sessionData.accountType == 'STU' && !this.violatePoint" class="form-control" rows="5" name="leaveRemark" v-model="violateRecord.recordRemark"  maxlength="400" v-validate="'max:400'"></textarea>
						<p v-else>{{violateRecord.recordRemark}}</p>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-offset-4 col-md-2">
						<a href="javascript:;" class="btn s_btn_b btn-block" @click="clickPrevious()">返回</a>
					</div>
					<div class="col-md-2" v-if="!this.violatePoint">
						<a href="javascript:;" class="btn btn-primary btn-block" @click="saveViolateRecord()">儲存</a>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
export default {
	mounted(){
		this.init();
		if (this.getStore(this.$route.name)) {
			this.storeData = JSON.parse(this.getStore(this.$route.name));
			this.violateRecord.account = this.storeData.account;
			this.violateRecord.sno = this.storeData.sno;
			this.searchStu();
		}
	},
	data(){
		return{
			isPrize:"N",
			model:{},
			violateRecord:{},
			violateTypeList:[],
			awardTypeList:[],
			isSaveShow:false,
			violatePoint:null,
			storeData:{}
		}
	},
	methods:{
		init(){
			const api = "/api/Common/violateList";
			this.$axios.post(api, JSON.stringify({})).then(resp => {
				this.violateTypeList = resp.data.data.filter(item => {
					return item.commType == "VIOLATE";
				});
				this.awardTypeList = resp.data.data.filter(item => {
					return item.commType == "AWARD";
				});
			});
		},
		searchStu(){
			if(!this.violateRecord.account){
				bootbox.alert("請確認必填欄位是否有填寫");
				return false;
			}else{
				const api = "/api/Violate/searchStuData/";
				this.$axios.post(api, JSON.stringify(this.violateRecord)).then(resp =>{
					if(resp.data.status == "success"){
						this.model = resp.data.data;

						this.violateRecord = {
							sno:this.model.sno,
							account:this.model.account,
							applyId:this.model.applyId,
							violateName:this.model.violateName,
							violatePoint:this.model.violatePoint,
							recordRemark:this.model.recordRemark,
							revokeApply:this.model.revokeApply,
              violateDate:this.model.violateDate ? new Date(this.model.violateDate) : null,
              crDate:this.model.crDate ? new Date(this.model.crDate) : null,
						};

						this.violatePoint = this.violateRecord.violatePoint;
						if(!this.violatePoint){
							if(this.isAdmin('stay')){
								this.isSaveShow = true;
							}
						}

					}else{
						bootbox.alert(resp.data.msg);
						this.$router.go(-1);
					}
				});
			}
		},
		buildSavePayload(){
			return Object.assign({}, this.violateRecord, {
				violateDate: this.violateRecord.violateDate
					? this.customFormatter(this.violateRecord.violateDate, "YYYY-MM-DD") + "T00:00:00"
					: null,
			});
		},
		saveViolateRecord(){
			let _this = this;
			this.$validator.validateAll().then(result =>{
				if(result){
					const api = "/api/Violate/saveViolateRecord/";
					this.$axios.post(api, JSON.stringify(this.buildSavePayload())).then(resp => {
						bootbox.alert(resp.data.msg, function(){
							if(resp.data.status == "success"){
								_this.$router.go(-1);
							}
						});
					});
				}else{
					bootbox.alert("請確認必填欄位是否有填寫");
				}
			});
		},
		clickPrevious() {
			this.$router.go(-1);
			this.$router.replace("",this.storeData);
		},
		clearFunc(){
			let keepSessionData = this.sessionData;
			let keepStoreData = this.storeData;
			Object.assign(this.$data, this.$options.data());
			this.sessionData = keepSessionData;
			this.storeData = keepStoreData;
			this.init();
		},
	},
	beforeRouteLeave(to, from, next) {
		this.removeStore(this.$route.name);
		next();
	}
}
</script>
